var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabSelect = function SvgTabSelect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9 4.8h-1.8v6.24c.265-.152.572-.24.9-.24.328 0 .635.087.9.24V4.8Zm0 9.359c-.265.153-.572.24-.9.24-.328 0-.635-.087-.9-.24v5.04h1.8v-5.04Z",
    fill: "#105880"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.7a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8Zm-2.7.9a2.7 2.7 0 1 1 5.4 0 2.7 2.7 0 0 1-5.4 0ZM5.4 4.8H3.6v11.04c.265-.152.572-.24.9-.24.328 0 .635.088.9.24V4.8Zm0 14.159c-.265.153-.572.24-.9.24-.328 0-.635-.087-.9-.24v.24h1.8v-.24Z",
    fill: "#105880"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 16.5a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8Zm-2.7.9a2.7 2.7 0 1 1 5.4 0 2.7 2.7 0 0 1-5.4 0ZM19.8 8.159c-.265.153-.572.24-.9.24-.328 0-.635-.087-.9-.24v11.04h1.8V8.16Zm0-3.118V4.8H18v.24c.265-.153.572-.24.9-.24.328 0 .635.087.9.24Z",
    fill: "#105880"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9 5.7a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8Zm-2.7.9a2.7 2.7 0 1 1 5.4 0 2.7 2.7 0 0 1-5.4 0Z",
    fill: "#105880"
  })));
};
export default SvgTabSelect;